import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { PHONES, CONTACT } from '../content';
import { DISTRICT_PAGES } from '../data/districts';
import { SERVICE_PAGES } from '../data/services-seo';

const NAV_LINKS = [
  { label: 'Anasayfa', to: '/' },
  { label: 'Acil Yol Yardım', to: '/acil-yol-yardim' },
  { label: 'Hizmetlerimiz', to: '/hizmetlerimiz' },
  { label: 'Garanti', to: '/garanti' },
  { label: 'Markalarımız', to: '/markalarimiz' },
  { label: 'Blog', to: '/blog' },
  { label: 'İletişim', to: '/iletisim' },
];

const CORP_LINKS = [
  { label: 'Hakkımızda', to: '/hakkimizda' },
  { label: 'Vizyonumuz', to: '/vizyonumuz' },
  { label: 'Misyonumuz', to: '/misyonumuz' },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{
        background: 'var(--bg2)',
        borderTop: '1px solid var(--border)',
        paddingTop: '5rem',
        paddingBottom: '2.5rem',
      }}
    >
      <div className="wrap">
        {/* Top grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.5fr 1fr 1fr 1fr 1.2fr 1fr',
            gap: '3rem 3.5rem',
            marginBottom: '3.5rem',
          }}
          className="footer-grid"
        >
          {/* Brand */}
          <div>
            <Link
              to="/"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '.875rem',
                marginBottom: '1.375rem',
              }}
            >
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: '50%',
                  background: 'var(--red)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 800,
                  fontSize: '.72rem',
                  color: '#fff',
                }}
              >
                7/24
              </div>
              <div>
                <div
                  style={{
                    fontFamily: "'Space Grotesk', sans-serif",
                    fontWeight: 700,
                    fontSize: '1.05rem',
                    color: 'var(--text)',
                  }}
                >
                  7/24 Lastik
                </div>
                <div style={{ fontSize: '.7rem', color: 'var(--muted)' }}>
                  Kocaeli Acil Yol Yardım
                </div>
              </div>
            </Link>

            <p
              style={{
                fontSize: '.9rem',
                color: 'var(--text2)',
                lineHeight: 1.75,
                marginBottom: '1.5rem',
                maxWidth: 300,
              }}
            >
              Kocaeli lastik yol yardım. En yakın lastikçi olarak İzmit, Gebze, Körfez ve tüm ilçelere 7/24 mobil lastik tamiri ve değişimi hizmeti.
            </p>

            {/* Contact details */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
              <a
                href={PHONES.main_tel}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '.5rem',
                  color: 'var(--red)',
                  fontSize: '.95rem',
                  fontWeight: 700,
                  textDecoration: 'none',
                  transition: 'opacity .2s',
                }}
                className="num"
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '.75')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                <Phone size={15} /> {PHONES.main}
              </a>
              <a
                href={`mailto:${CONTACT.email}`}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '.5rem',
                  color: 'var(--text2)',
                  fontSize: '.875rem',
                  textDecoration: 'none',
                  transition: 'color .2s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--text)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text2)')}
              >
                <Mail size={14} /> {CONTACT.email}
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <div
              style={{
                fontSize: '.72rem',
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--text2)',
                marginBottom: '1.125rem',
              }}
            >
              Sayfalar
            </div>
            <ul
              style={{
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '.625rem',
              }}
            >
              {NAV_LINKS.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    style={{
                      fontSize: '.875rem',
                      color: 'var(--text2)',
                      transition: 'color .2s',
                    }}
                    onMouseEnter={(e) => (e.target.style.color = 'var(--text)')}
                    onMouseLeave={(e) => (e.target.style.color = 'var(--text2)')}
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hizmetler */}
          <div>
            <div
              style={{
                fontSize: '.72rem',
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--text2)',
                marginBottom: '1.125rem',
              }}
            >
              Hizmetlerimiz
            </div>
            <ul
              style={{
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '.5rem',
              }}
            >
              {SERVICE_PAGES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/${s.slug}`}
                    style={{
                      fontSize: '.8rem',
                      color: 'var(--text2)',
                      transition: 'color .2s',
                    }}
                    onMouseEnter={(e) => (e.target.style.color = 'var(--text)')}
                    onMouseLeave={(e) => (e.target.style.color = 'var(--text2)')}
                  >
                    {s.h1}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Kurumsal */}
          <div>
            <div
              style={{
                fontSize: '.72rem',
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--text2)',
                marginBottom: '1.125rem',
              }}
            >
              Kurumsal
            </div>
            <ul
              style={{
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '.625rem',
              }}
            >
              {CORP_LINKS.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    style={{
                      fontSize: '.875rem',
                      color: 'var(--text2)',
                      transition: 'color .2s',
                    }}
                    onMouseEnter={(e) => (e.target.style.color = 'var(--text)')}
                    onMouseLeave={(e) => (e.target.style.color = 'var(--text2)')}
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div
              style={{
                fontSize: '.72rem',
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--text2)',
                marginBottom: '1.125rem',
              }}
            >
              Hizmet Bölgeleri
            </div>
            <ul
              style={{
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: '.5rem',
              }}
            >
              {DISTRICT_PAGES.slice(0, 7).map((d) => (
                <li key={d.slug}>
                  <Link
                    to={`/${d.slug}`}
                    style={{
                      fontSize: '.8rem',
                      color: 'var(--text2)',
                      transition: 'color .2s',
                    }}
                    onMouseEnter={(e) => (e.target.style.color = 'var(--text)')}
                    onMouseLeave={(e) => (e.target.style.color = 'var(--text2)')}
                  >
                    {d.displayName || d.name} Lastik Yol Yardım
                  </Link>
                </li>
              ))}
              <li style={{ marginTop: '.25rem' }}>
                <Link
                  to="/acil-yol-yardim"
                  style={{ fontSize: '.75rem', color: 'var(--blue)', fontWeight: 600, transition: 'opacity .2s' }}
                >
                  Tüm ilçeler →
                </Link>
              </li>
            </ul>
          </div>

          {/* Iletisim */}
          <div>
            <div
              style={{
                fontSize: '.72rem',
                fontWeight: 700,
                letterSpacing: '.06em',
                textTransform: 'uppercase',
                color: 'var(--text2)',
                marginBottom: '1.125rem',
              }}
            >
              İletişim
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'flex', gap: '.75rem' }}>
                <Phone
                  size={16}
                  style={{ color: 'var(--blue)', marginTop: 2, flexShrink: 0 }}
                />
                <div>
                  <div
                    style={{
                      fontSize: '.7rem',
                      color: 'var(--muted)',
                      marginBottom: '.15rem',
                      textTransform: 'uppercase',
                      letterSpacing: '.04em',
                    }}
                  >
                    Telefon
                  </div>
                  <a
                    href={PHONES.main_tel}
                    style={{
                      color: 'var(--text2)',
                      fontSize: '.875rem',
                      transition: 'color .2s',
                    }}
                    className="num"
                    onMouseEnter={(e) => (e.target.style.color = 'var(--text)')}
                    onMouseLeave={(e) => (e.target.style.color = 'var(--text2)')}
                  >
                    {PHONES.main}
                  </a>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '.75rem' }}>
                <Mail
                  size={16}
                  style={{ color: 'var(--blue)', marginTop: 2, flexShrink: 0 }}
                />
                <div>
                  <div
                    style={{
                      fontSize: '.7rem',
                      color: 'var(--muted)',
                      marginBottom: '.15rem',
                      textTransform: 'uppercase',
                      letterSpacing: '.04em',
                    }}
                  >
                    E-Posta
                  </div>
                  <a
                    href={`mailto:${CONTACT.email}`}
                    style={{
                      color: 'var(--text2)',
                      fontSize: '.875rem',
                      transition: 'color .2s',
                      wordBreak: 'break-word',
                    }}
                    onMouseEnter={(e) => (e.target.style.color = 'var(--text)')}
                    onMouseLeave={(e) => (e.target.style.color = 'var(--text2)')}
                  >
                    {CONTACT.email}
                  </a>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '.75rem' }}>
                <MapPin
                  size={16}
                  style={{ color: 'var(--blue)', marginTop: 2, flexShrink: 0 }}
                />
                <div>
                  <div
                    style={{
                      fontSize: '.7rem',
                      color: 'var(--muted)',
                      marginBottom: '.15rem',
                      textTransform: 'uppercase',
                      letterSpacing: '.04em',
                    }}
                  >
                    Bölge
                  </div>
                  <span style={{ color: 'var(--text2)', fontSize: '.875rem' }}>
                    Kocaeli — Tüm İlçeler
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider + bottom */}
        <div
          style={{
            borderTop: '1px solid var(--border)',
            paddingTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1.25rem',
          }}
        >
          <p style={{ fontSize: '.8rem', color: 'var(--muted)' }}>
            © 2017–{new Date().getFullYear()} 7/24 Lastik Yol Yardım — Tüm hakları saklıdır.
          </p>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            {[{ l: 'Garanti', t: '/garanti' }, { l: 'Blog', t: '/blog' }, { l: 'İletişim', t: '/iletisim' }].map((n) => (
              <Link
                key={n.t}
                to={n.t}
                style={{
                  fontSize: '.8rem',
                  color: 'var(--muted)',
                  transition: 'color .2s',
                }}
                onMouseEnter={(e) => (e.target.style.color = 'var(--text2)')}
                onMouseLeave={(e) => (e.target.style.color = 'var(--muted)')}
              >
                {n.l}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 2.5rem 1.5rem !important;
          }
          .footer-grid > div:first-child {
            grid-column: 1 / -1;
          }
        }
        @media(max-width: 480px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
        }
      `}</style>
    </footer>
  );
}
